define('model/disclosure.routing.history.model',['require','exports','module','fukit'],function(require, exports, module) {
  var BaseModel = require('fukit').BaseModel;

  var DisclosureRoutingHistoryModel = BaseModel.extend({
    radioRequests: {
      'models DisclosureRoutingHistoryModel': '@constructor',
    },
  });

  DisclosureRoutingHistoryModel.Collection = DisclosureRoutingHistoryModel.Collection.extend({
    url: BaseModel.urlTemplate('/api/v1/coi-workflow/history/routing/:documentId'),
  });

  module.exports = DisclosureRoutingHistoryModel;
});

